import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import VehicleListingPage from './pages/VehicleListingPage';
import VehicleDetailPage from './pages/VehicleDetailPage';
import ContactPage from './pages/ContactPage';
import SearchPage from './pages/SearchPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TrackingPage from './pages/TrackingPage';




import FeaturedInventoryDetailPage from './pages/FeaturedInventoryDetailPage';
import FeaturedInventoryPage from './pages/FeaturedInventoryPage';
import HowItWorksPage from './pages/HowItWorksPage';

// Admin pages are code-split so regular visitors never download them
const AdminLoginPage = lazy(() => import('./pages/AdminLoginPage'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const AdminVehicleForm = lazy(() => import('./pages/AdminVehicleForm'));
const AdminSocialMedia = lazy(() => import('./pages/AdminSocialMedia'));

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<div />}>
        <Routes>
          {/* Admin Routes (no header/footer) */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/featured-inventory/:id" element={<AdminVehicleForm />} />
          <Route path="/admin/social-media" element={<AdminSocialMedia />} />
          
          {/* Public Routes (with header/footer) */}
          <Route path="/*" element={
            <div className="min-h-screen bg-gray-50 flex flex-col">
              <Header />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/vehicles" element={<VehicleListingPage />} />
                  <Route path="/vehicles/:slug" element={<VehicleDetailPage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/tracking" element={<TrackingPage />} />
                  <Route path="/available" element={<FeaturedInventoryPage />} />
                  <Route path="/featured-inventory/:id" element={<FeaturedInventoryDetailPage />} />
                  <Route path="/how-it-works" element={<HowItWorksPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
          } />
        </Routes>
        </Suspense>
      </Router>
    </QueryClientProvider>
  );
}

export default App;